import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthHeader } from '@app/shared/components/header/auth-header/auth-header';
import { FeedbackWidget } from '@shared/components/feedback-widget/feedback-widget';

@Component({
  selector: 'app-auth-layout',
  imports: [CommonModule, RouterOutlet, AuthHeader, FeedbackWidget],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss',
})
export class AuthLayout {}
